import { useState, useEffect } from 'react';
import { Plus, Save, AlertTriangle, ChevronDown, Image, PenLine, X } from 'lucide-react';
import {
  Package,
  Percent,
  IndianRupee,
  LayoutGrid,
  CalendarDays,
  CalendarCheck,
  Tag,
  Clock,
  Gift,
} from 'lucide-react';

import Sidebar from '../../component/b2c/sidebar/sidebar';
import NavBar from '../../component/b2c/navBar/navBar';
import { useMyContext } from '../../context/MyContext';
import { Base_Url, setOffer } from '../../config/config';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function OfferSessionPanel() {
  const { isToggleSidebar, isDarkMode } = useMyContext();

  const navigate = useNavigate();

  const [newOffer, setNewOffer] = useState({
    threshold: '',
    description: '',
    discountType: "Percentage",
    category: 'All',
    startDate: '',
    endDate: '',
    image: ''
  });

  const [editingId, setEditingId] = useState(null);
  const [savedMessage, setSavedMessage] = useState('');
  const [messageType, setMessageType] = useState('success');

  const [activeTab, setActiveTab] = useState('current');

  const categories = ['All', 'shipment cashback'];

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);

    setNewOffer(prev => ({
      ...prev,
      startDate: today,
      endDate: nextMonth.toISOString().split('T')[0]
    }));
  }, []);

  const validateForm = () => {
    const { threshold, discountType, startDate, endDate, description, image } = newOffer;

    if (!threshold || !discountType || !startDate || !endDate || !image || !description) {
      showMessage("Please fill all required fields", "error");
      return false;
    }

    if (new Date(startDate) > new Date(endDate)) {
      showMessage("End date must be after start date", "error");
      return false;
    }

    return true;
  };

  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');

  const addOffer = async () => {
    if (!validateForm()) return;

    const thresholdValue = parseFloat(newOffer.threshold);
    try {
      const formData = new FormData();
      formData.append('category', newOffer.category);
      formData.append('discount_type', newOffer.discountType);
      formData.append('discount_value', thresholdValue);
      formData.append('description', newOffer.description);

      const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };

      formData.append('start_date', formatDate(newOffer.startDate));
      formData.append('end_date', formatDate(newOffer.endDate));

      if (newOffer.image) {
        formData.append('image', newOffer.image);
      }

      const response = await fetch(Base_Url + setOffer, {
        method: 'POST',
        headers: {
          "cus_id": cus_id,
          "token": token,
        },
        body: formData
      });

      const result = await response.json();
      if (result.status === "SUCCESS") {
        toast.success(result.message);
        navigate('/dashboard')
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Failed to add offer. Please try again.", "error");
    }
  };

  const showMessage = (message, type = 'success') => {
    setSavedMessage(message);
    setMessageType(type);

    setTimeout(() => {
      setSavedMessage('');
    }, 3000);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewOffer(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
      <div className="z-10">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
            <Sidebar />
          </div>
        )}

        <div className="flex-1 bg-gray-100 dark:bg-black overflow-y-auto p-3 md:p-4">
          <div className="max-w-5xl mx-auto">

            {/* Header */}
            <div className="mb-5">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900">
                  <Gift size={16} className="text-gray-700 dark:text-gray-300" />
                </div>
                <div>
                  <h1 className="text-base font-bold text-gray-800 dark:text-white tracking-tight">
                    Offer Management
                  </h1>
                  <p className="text-[10px] text-gray-400 dark:text-gray-500">
                    Create and manage promotional offers for your customers
                  </p>
                </div>
              </div>
            </div>

            {/* Stats Bar */}
            {/* <div className="grid grid-cols-3 gap-2 mb-4">
              <div className="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 p-2.5 text-center">
                <p className="text-[9px] text-gray-400 dark:text-gray-500 uppercase tracking-wider">Active</p>
                <p className="text-sm font-bold text-gray-800 dark:text-white">0</p>
              </div>
              <div className="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 p-2.5 text-center">
                <p className="text-[9px] text-gray-400 dark:text-gray-500 uppercase tracking-wider">Scheduled</p>
                <p className="text-sm font-bold text-gray-800 dark:text-white">0</p>
              </div>
              <div className="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 p-2.5 text-center">
                <p className="text-[9px] text-gray-400 dark:text-gray-500 uppercase tracking-wider">Expired</p>
                <p className="text-sm font-bold text-gray-800 dark:text-white">0</p>
              </div>
            </div> */}

            {/* Tabs */}
            <div className="flex mb-4 border-b border-gray-200 dark:border-gray-800">
              <button
                className={`px-3 py-1.5 text-[10px] font-medium uppercase tracking-wider transition-colors relative ${
                  activeTab === 'current'
                    ? 'text-gray-800 dark:text-white'
                    : 'text-gray-400 dark:text-gray-600 hover:text-gray-600 dark:hover:text-gray-300'
                }`}
                onClick={() => setActiveTab('current')}
              >
                Create Offer
                {activeTab === 'current' && (
                  <div className="absolute -bottom-px left-0 w-full h-0.5 bg-gray-800 dark:bg-white"></div>
                )}
              </button>
            </div>

            {activeTab === 'current' && (
              <>
                {/* Offer Form */}
                <div className="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-gray-800 shadow-sm overflow-hidden">
                  
                  {/* Form Header */}
                  <div className="px-4 py-3 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-900/50">
                    <div className="flex items-center gap-2">
                      <div className="p-1 rounded border border-gray-300 dark:border-gray-700">
                        <Tag size={12} className="text-gray-600 dark:text-gray-400" />
                      </div>
                      <span className="text-[10px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider">
                        New Offer Details
                      </span>
                    </div>
                  </div>

                  {/* Form Body */}
                  <div className="p-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

                      {/* Discount Type & Value */}
                      <div className="space-y-1">
                        <label className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                          Discount *
                        </label>
                        <div className="flex gap-1.5">
                          <div className="relative w-2/5">
                            <select
                              name="discountType"
                              value={newOffer.discountType}
                              onChange={handleInputChange}
                              className="w-full text-[11px] border rounded-lg border-gray-300 dark:border-gray-700 px-2.5 py-2 appearance-none focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 bg-white dark:bg-black text-gray-800 dark:text-white transition-all"
                            >
                              <option value="Percentage">%</option>
                              <option value="Flat">₹</option>
                            </select>
                            <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                              <ChevronDown size={10} className="text-gray-400" />
                            </div>
                          </div>
                          <div className="relative w-3/5">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-2.5 pointer-events-none">
                              {newOffer.discountType === "Percentage" ? (
                                <Percent size={10} className="text-gray-400" />
                              ) : (
                                <IndianRupee size={10} className="text-gray-400" />
                              )}
                            </div>
                            <input
                              type="number"
                              name="threshold"
                              value={newOffer.threshold}
                              onChange={handleInputChange}
                              placeholder="Value"
                              min="0"
                              max={newOffer.discountType === "Percentage" ? "100" : undefined}
                              className="w-full text-[11px] border rounded-lg border-gray-300 dark:border-gray-700 pl-6 pr-2.5 py-2 focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 bg-white dark:bg-black text-gray-800 dark:text-white transition-all"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Category */}
                      <div className="space-y-1">
                        <label className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                          Category *
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-2.5 pointer-events-none">
                            <LayoutGrid size={10} className="text-gray-400" />
                          </div>
                          <select
                            name="category"
                            value={newOffer.category}
                            onChange={handleInputChange}
                            className="w-full text-[11px] border rounded-lg border-gray-300 dark:border-gray-700 pl-7 pr-7 py-2 appearance-none focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 bg-white dark:bg-black text-gray-800 dark:text-white transition-all"
                          >
                            {categories.filter(category => category !== 'All').map(category => (
                              <option key={category} value={category}>{category}</option>
                            ))}
                          </select>
                          <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                            <ChevronDown size={10} className="text-gray-400" />
                          </div>
                        </div>
                      </div>

                      {/* Start Date */}
                      <div className="space-y-1">
                        <label className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                          Start Date *
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-2.5 pointer-events-none">
                            <CalendarDays size={10} className="text-gray-400" />
                          </div>
                          <input
                            type="date"
                            name="startDate"
                            value={newOffer.startDate}
                            onChange={handleInputChange}
                            className="w-full text-[11px] border rounded-lg border-gray-300 dark:border-gray-700 pl-7 pr-2.5 py-2 focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 bg-white dark:bg-black text-gray-800 dark:text-white transition-all"
                          />
                        </div>
                      </div>

                      {/* End Date */}
                      <div className="space-y-1">
                        <label className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                          End Date *
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-2.5 pointer-events-none">
                            <CalendarCheck size={10} className="text-gray-400" />
                          </div>
                          <input
                            type="date"
                            name="endDate"
                            value={newOffer.endDate}
                            onChange={handleInputChange}
                            className="w-full text-[11px] border rounded-lg border-gray-300 dark:border-gray-700 pl-7 pr-2.5 py-2 focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 bg-white dark:bg-black text-gray-800 dark:text-white transition-all"
                          />
                        </div>
                      </div>

                      {/* Description */}
                      <div className="space-y-1">
                        <label className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                          Description
                        </label>
                        <input
                          type="text"
                          name="description"
                          value={newOffer.description}
                          onChange={handleInputChange}
                          placeholder="Short description"
                          className="w-full text-[11px] border rounded-lg border-gray-300 dark:border-gray-700 px-2.5 py-2 focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 bg-white dark:bg-black text-gray-800 dark:text-white transition-all"
                        />
                      </div>

                      {/* Image Upload */}
                      <div className="space-y-1">
                        <label className="block text-[9px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                          Offer Image
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-2.5 pointer-events-none">
                            <Image size={10} className="text-gray-400" />
                          </div>
                          <input
                            type="file"
                            name="image"
                            accept="image/*"
                            onChange={(e) =>
                              setNewOffer({ ...newOffer, image: e.target.files[0] })
                            }
                            className="w-full text-[11px] border rounded-lg border-gray-300 dark:border-gray-700 pl-7 pr-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 bg-white dark:bg-black text-gray-800 dark:text-white transition-all file:mr-2 file:py-1 file:px-3 file:rounded-lg file:border file:border-gray-300 dark:file:border-gray-700 file:text-[10px] file:font-medium file:bg-gray-100 dark:file:bg-gray-800 file:text-gray-700 dark:file:text-gray-300 hover:file:bg-gray-200 dark:hover:file:bg-gray-700"
                          />
                        </div>
                        {newOffer.image && (
                          <div className="mt-1.5 relative inline-block">
                            <img
                              src={URL.createObjectURL(newOffer.image)}
                              alt="Preview"
                              className="w-14 h-14 object-cover rounded-lg border border-gray-200 dark:border-gray-700"
                            />
                            <button
                              onClick={() => setNewOffer({ ...newOffer, image: '' })}
                              className="absolute -top-1 -right-1 p-0.5 rounded-full bg-gray-800 dark:bg-gray-700 text-white hover:bg-gray-700 dark:hover:bg-gray-600 transition-colors"
                            >
                              <X size={10} />
                            </button>
                          </div>
                        )}
                      </div>

                    </div>

                    {/* Form Footer */}
                    <div className="mt-4 pt-3 border-t border-gray-100 dark:border-gray-800 flex justify-end">
                      <button
                        onClick={addOffer}
                        className="px-5 py-2 bg-gray-800 dark:bg-white text-white dark:text-gray-800 text-[11px] font-medium rounded-lg hover:opacity-80 transition-all flex items-center gap-1.5 shadow-sm"
                      >
                        <Plus size={12} /> Create Offer
                      </button>
                    </div>
                  </div>
                </div>

                {/* Empty State */}
                {/* <div className="mt-4 text-center py-6">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full border-2 border-dashed border-gray-300 dark:border-gray-700 mb-2">
                    <Gift size={20} className="text-gray-400 dark:text-gray-600" />
                  </div>
                  <p className="text-[11px] text-gray-400 dark:text-gray-500">
                    No offers created yet. Fill out the form above to get started.
                  </p>
                </div> */}
              </>
            )}

            {/* Notification Toast */}
            {savedMessage && (
              <div className={`fixed bottom-4 right-4 px-3 py-2.5 text-[11px] rounded-lg border flex items-center shadow-lg ${
                messageType === 'success'
                  ? 'bg-gray-800 text-white border-gray-700 dark:bg-white dark:text-gray-800 dark:border-gray-200'
                  : 'bg-white text-gray-800 border-gray-300 dark:bg-gray-800 dark:text-white dark:border-gray-700'
                }`}>
                {messageType === 'success' ? (
                  <Save size={13} className="mr-1.5" />
                ) : (
                  <AlertTriangle size={13} className="mr-1.5" />
                )}
                {savedMessage}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}